export default "__VITE_ASSET__JFvdH9K5__"